export const appendCount = (label: string, count: number) => {
  if (count === 0) return label;

  return `${label} (${count})`;
};
